import React, { useContext, useState, useEffect } from 'react'
// eslint-disable-next-line
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { HomePage } from './pages/HomePage'
import { TrackDetails } from './components/SearchResults/TrackDetails'
import { ByArtist } from './components/SearchResults/ByArtist'
import { ByAlbum } from './components/SearchResults/ByAlbum'
import { GlobalMusicContext } from './context/GlobalMusicContext'
import PlaylistDetails from './components/Playlists/PlaylistDetails'
import { SearchResultsList } from './components/SearchResults/SearchResultsList'
import { LatestTrackslist } from './components/SearchResults/LatestTrackslist'
import { OfficialChartsList } from './components/Playlists/OfficialCharts'
import { QueueList } from './components/Playlists/QueueList'
import { EntryPoint } from './pages/EntryPoint'
import { Loading } from './components/helpers/Loading'
import { LatestAlbumsAll } from './components/Discover/LatestAlbumsAll'
import { useWindowResize } from './hooks/useWindowResize'
import { UserPlaylists } from './components/Playlists/UserPlaylists'
import UserContext from './context/AuthContext'
import { useAuth } from './hooks/useAuth'

function Routes( { history, location } ) {
  const [{ currentTrack, searchResults }] = useContext( GlobalMusicContext )
  let previousLocation
  const [redirectState, setRedirectState] = useState( null )
  // eslint-disable-next-line
  let artist = currentTrack.ar && currentTrack.ar[0].name
  let album = currentTrack.al && currentTrack.al.name

  let mediaSession = navigator.mediaSession
  if ( "mediaSession" in navigator ) {
    navigator.mediaSession.metadata = new window.MediaMetadata( {
      title: currentTrack.name,
      artist: artist,
      album: album,
    } )
  }

  useEffect( () => {
    if ( redirectState && history.location.pathname === "/" ) {
      history.replace( "/home" )
    }
  }, [setRedirectState, history, redirectState] )

  const checkPrevLocation = () => {
    if ( location.pathname === "/play" ) {
      return previousLocation
    } else {
      return location
    }
  }
  const { width } = useWindowResize()
  // console.log( width, "width" )
  const [Auth, setAuth] = useAuth()

  return (
    <React.Suspense fallback={<Loading />}>
      <Switch location={checkPrevLocation()}>
        {history.location.pathname === "/"
          ? <Redirect to="/home" />
          : null
        }
        <Route path="/home" render={props => {
          return <HomePage
            {...props}
          />
        }} />
        <Route exact path="/search" render={props => {
          return <SearchResultsList
            {...props}
            results={searchResults}
          />
        }} />
        <Route exact path="/about" component={EntryPoint} />
        <UserContext.Provider value={{ Auth, setAuth }}>
          <Route exact path="/artists/:id" component={ByArtist} />
          <Route exact path="/album/:id" component={ByAlbum} />
          <Route exact path="/discovery/latest/music" component={LatestTrackslist} />
          <Route exact path="/song/:id" component={TrackDetails} />
          <Route exact path="/playlists" component={OfficialChartsList} />
          <Route exact path="/playlist/:id" component={PlaylistDetails} />
          <Route exact path="/user/playlists/:id" component={UserPlaylists} />
          <Route exact path="/discovery/latest/albums" component={LatestAlbumsAll} />
        </UserContext.Provider>
      </Switch>
      <Route exact path="/mobile" component={QueueList} />
    </React.Suspense>
  )
}
export default withRouter( Routes )